var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Toolbar'),_c('DataTable',{attrs:{"opt":_vm.optDataTable,"title":_vm.title,"collection":_vm.collection,"integration":true,"register":_vm.register,"filters":_vm.filters,"details":_vm.details,"claims":_vm.claims}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }